export const PROGRESS_BAR_WIDTH = '90%';

export const STATUS = {
  PRINTED: 'PRINTED',
  FAILED: 'FAILED'
};

export const ERROR_CODE = {
  E1342: 'E1342'
};

export const ERROR_TEXT = {
  ARCHIVE: 'archive',
  GENERAL_LEDGER: 'general ledger',
  CHECK_FORM: 'render check form'
};

export const ERROR_KEYS = {
  ARCHIVE: 'ARCHIVE',
  GENERAL_LEDGER: 'GENERAL_LEDGER',
  CHECK_FORM: 'CHECK_FORM'
};

export const PRINT_SUCCESS_TABLE_HEIGHT = '150px';
export const PRINT_SUCCESS_TABLE_WIDTH = '100%';
